import { render, staticRenderFns } from "./carta.vue?vue&type=template&id=27d7ccec&scoped=true&"
import script from "./carta.vue?vue&type=script&lang=js&"
export * from "./carta.vue?vue&type=script&lang=js&"
import style0 from "./carta.vue?vue&type=style&index=0&id=27d7ccec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7ccec",
  null
  
)

export default component.exports